import classNames from "classnames"
import { toUpper } from "lodash"
import { Tab } from "@mui/material"
import { upsellingTitle } from "helpers/op-pro"
import Tooltip from "components/material/tooltip"
import RouterAnchor from "components/router-anchor"
import { UpsellTabPropTypes } from "./shapes"

export default function UpsellTab({ id, label, url, disabled, align = "left", selected = false, tooltip }) {
  const urlProps = selected || !url ? {} : { component: RouterAnchor, to: url }
  const tabElement = <Tab id={id} label={toUpper(label)} disabled={disabled} {...urlProps} className={classNames("upsell-tab", { align, selected })} />
  if (disabled) {
    return <Tooltip className="disabled" title={tooltip || upsellingTitle(disabled, label)}>
      <div>
        {tabElement}
      </div>
    </Tooltip>
  }
  return tabElement
}

UpsellTab.propTypes = UpsellTabPropTypes
